export default __webpack_public_path__ + "static/media/plus_primary.b1535082.svg";